import {LoadSpacingScenario} from '../../fields/loadSpacing/types'

import {SlotFormData} from './types'

/**
 * Validates that all required fields are present for slot request.
 */
export const validateSlotFormData = (
  formData: SlotFormData,
  options: {
    loadSpacingScenario?: LoadSpacingScenario
    dateTime?: string
    contractNumber?: string
    contractItemPositionNumber?: string
    orgUnitId?: string
  } = {}
): string[] => {
  const {loadSpacingScenario, dateTime, contractNumber, contractItemPositionNumber, orgUnitId} = options
  const missingFields: string[] = []

  // Required: dateTime
  if (!dateTime) {
    missingFields.push('dateTime')
  }

  // Required: contract — form value takes precedence, option fallbacks are accepted too
  const resolvedContractNumber = formData.contract?.contractNumber ?? contractNumber
  const resolvedContractItemPositionNumber =
    formData.contract?.contractItemPositionNumber ?? contractItemPositionNumber
  if (!resolvedContractNumber || !resolvedContractItemPositionNumber) {
    missingFields.push('contract')
  }

  // Required: orgUnitId — must not be sent empty to the slot APIs
  if (!orgUnitId) {
    missingFields.push('orgUnitId')
  }

  // Required: quantity
  const quantityNumericValue =
    formData.quantity?.type === 'volume'
      ? formData.quantity.volume
      : formData.quantity?.type === 'fullLoads'
        ? formData.quantity.fullLoads
        : undefined
  if (quantityNumericValue === undefined || quantityNumericValue === null) {
    missingFields.push('quantity')
  }

  // Conditional: spacing fields based on scenario
  if (loadSpacingScenario) {
    const needsLoadSpace = loadSpacingScenario.loadSpace
    const needsFlowRate = loadSpacingScenario.flowRate
    const needsTimeOnJobSite = loadSpacingScenario.timeOnJobSite

    if (needsLoadSpace && !formData.spacingOrFlowRate) {
      missingFields.push('spacingOrFlowRate')
    }
    if (needsFlowRate && !formData.spacingOrFlowRate) {
      missingFields.push('spacingOrFlowRate')
    }
    if (needsTimeOnJobSite && !formData.timeOnJobSite) {
      missingFields.push('timeOnJobSite')
    }
  }

  return missingFields
}
